import React from 'react';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { localizedPath } from '../utils/routes';

export default function PaymentResult({ type }) {
  const { t, language } = useLanguage();
  const { lang } = useParams();
  const currentLang = lang || language;
  const lp = (routeName) => localizedPath(routeName, currentLang);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const appointmentId = searchParams.get('appointment_id');

  const isSuccess = type === 'success';

  return (
    <div style={{ background: '#0C1220', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <div style={{ textAlign: 'center', maxWidth: '500px' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>{isSuccess ? '✓' : '✕'}</div>
        <div style={{ color: isSuccess ? '#22c55e' : '#D42B2B', fontSize: '0.6rem', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '1rem' }}>
          {isSuccess ? t.booking.success.depositPaid : t.booking.paymentPending}
        </div>
        <h2 style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: '2.5rem', color: '#E8ECF0', fontWeight: 300, marginBottom: '1rem' }}>
          {isSuccess ? t.booking.paymentSuccess : t.booking.paymentCancelled}
        </h2>
        <p style={{ color: '#64748B', fontSize: '0.9rem', lineHeight: 1.8, marginBottom: '2rem' }}>
          {isSuccess
            ? (currentLang === 'fr'
              ? 'Votre dépôt a été reçu avec succès. Vous pouvez voir les détails dans votre tableau de bord.'
              : 'Your deposit has been received successfully. You can view the details in your dashboard.')
            : (currentLang === 'fr'
              ? 'Vous pouvez réessayer le paiement depuis votre tableau de bord ou nous contacter pour assistance.'
              : 'You can retry payment from your dashboard or contact us for assistance.')}
        </p>
        <button onClick={() => navigate(lp('dashboard'))} className="btn btn-primary" style={{ padding: '1rem 2.5rem' }}>
          {t.booking.success.viewButton}
        </button>
      </div>
    </div>
  );
}
